var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBenefit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 133,
    viewBox: "0 0 133 133",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 .637h132.362V133H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -.637)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M132.362 66.818c0 36.55-29.63 66.182-66.18 66.182C29.631 133 0 103.369 0 66.818S29.631.637 66.181.637c36.551 0 66.181 29.63 66.181 66.18",
    fill: "#3A913F",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M77.621 42.552l-7.925 8.393-7.023-4.565-6.23 13.028-8.146-5.155-8 9.425 7.3-12.964 7.925 4.344 5.936-13.545 7.924 5.008 5.222-6.599-3.284-2.863 10.222-2.531-1.115 10.47zM50.347 87.78c.242.124 2.234 1.067 4.365-.413.5-.349.889-.672 1.265-.984 1.68-1.396 2.778-2.096 7.539-1.45 4.949.672 15.248 2.071 18.848-2.376 3.539-4.37 16.292-23.41 17.118-24.644.184-.496 1.405-4.018-.305-5.671-1.952-1.887-5.113-.895-6.644.547-1.395 1.313-7.102 9.313-9.924 13.358l-.033-.022v.008c.47 3.988-1.362 5.71-1.44 5.782l-.074.058c-.324.22-8.027 5.368-15.843 3.284l.336-1.263c6.945 1.853 14.08-2.648 14.727-3.07.197-.209 1.358-1.58.998-4.638a2.188 2.188 0 0 0-.151-.594c-.843-1.981-4.974-.93-5.371-.822-.616.252-6.653 2.569-15.034-.07-7.918-2.491-14.448 3.197-14.763 3.477l-8.72 8.934c-.062.33-.12 1.398 1.413 2.465 2.2 1.532 11.094 7.689 11.693 8.103m1.847 1.718c-1.426 0-2.437-.55-2.506-.59l-.053-.032c-.095-.067-9.46-6.549-11.727-8.126-2.683-1.867-1.895-4.018-1.86-4.108l.048-.127 8.97-9.19c.074-.067 1.833-1.663 4.684-2.936 3.794-1.69 7.724-1.979 11.367-.833 8.173 2.574 14.112.12 14.17.095l.074-.026c.215-.063 5.005-1.428 6.69 1.044 1.843-2.626 7.993-11.329 9.587-12.83 1.91-1.8 5.91-2.988 8.447-.535 2.464 2.382.665 6.96.587 7.156l-.025.061-.038.057c-.552.826-13.553 20.261-17.23 24.803-4.062 5.017-14.853 3.552-20.04 2.848-4.412-.6-5.118-.011-6.527 1.159-.38.316-.808.671-1.355 1.052-1.168.812-2.308 1.058-3.263 1.058"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.459 65.784l-1.038-.793 7.003-9.164a6.342 6.342 0 0 1 2.984-2.159c1.578-.544 3.845-1.015 5.68-.167l-.548 1.185c-1.44-.665-3.355-.25-4.707.216a5.051 5.051 0 0 0-2.372 1.718l-7.002 9.164z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.585 64.326l-1.058-.766 7.797-10.774.044-.04c.038-.038 3.93-3.665 8.38-.566l-.746 1.071c-1.504-1.047-3.09-1.292-4.715-.729a6.204 6.204 0 0 0-1.979 1.133l-7.723 10.671z",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefit);
export default __webpack_public_path__ + "static/media/benefit.b0ed8817ec08ab65a777bd872de45d86.svg";
export { ForwardRef as ReactComponent };